import { Component, OnInit } from '@angular/core';
// import { TranslateService } from '@ngx-translate/core';
import { MatDialogRef,  MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as $ from 'jquery';

@Component({
  selector: 'app-product',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.css']
})
export class ProductComponent implements OnInit {

  constructor(
    // private translate: TranslateService,
    private _mdr: MatDialogRef<ProductComponent>,

  ) {
    localStorage.setItem("lang",'en')
    // translate.setDefaultLang(localStorage.getItem('lang'));
   }

  ngOnInit(): void {
  }

  Close(){
    this._mdr.close(false)
  }


  CloseScroll(){
  //   $('html, body').animate({
  //     scrollTop: $($('cnt-btn').attr('data-href')).offset().top
  // }, 2000);
  $('html, body').animate({scrollTop: 6857}, '300');
    this._mdr.close(false)
  }

}
